module.exports = __webpack_public_path__ + "static/media/fullscreen-img.f23a0524.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fullscreen-img.svg
// module id = 834
// module chunks = 0